import { useCompany } from "../context/CompanyContext";

function Header() {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const { company } = useCompany();

  const userName =
    storedUser?.name ||
    storedUser?.full_name ||
    storedUser?.fullName ||
    storedUser?.displayName ||
    storedUser?.username ||
    storedUser?.ownerName ||
    "Owner";

  return (
    <div className="bg-white p-4 sm:p-6 rounded-2xl shadow mb-6 w-full">
      
      <div className="flex flex-col gap-4">

        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">

          <div className="min-w-0">
            <h1 className="text-xl sm:text-3xl font-bold text-slate-800 leading-tight">
              Welcome, {userName} 👋
            </h1>

            <p className="text-sm sm:text-base text-gray-500 mt-1">
  {company?.company_name || storedUser?.company_name || "NOT LOADED"}
</p>
          </div>

          <div className="w-full sm:w-auto">
            <input
              type="text"
              placeholder="Search..."
              className="
                w-full sm:w-72
                border border-gray-300
                px-4 py-2
                rounded-lg
                text-sm
                focus:outline-none
                focus:ring-2
                focus:ring-blue-500
              "
            />
          </div>

        </div>

      </div>
    </div>
  );
}

export default Header;